import React from "react";
import {Col, Form, Row} from "react-bootstrap";
import styled from "styled-components";

export const Border = styled(Row)`
  border: 1px solid black;
  border-radius: 15px;
  justify-content: center;
  padding: 10px;
  margin-top: 50px;
`

export const ButtonGroup = styled.div`
  gap: 10px;
  display: flex;
  flex-direction: column;
  button {
    width: 70%;
    align-self: center;
  }
`

export const InputGroup = styled.div`
  gap: 10px;
  display: flex;
  margin-bottom: 20px;
  justify-content: center;
`

export const FormInput = styled(Form.Control)`
  font-size: 30px;
  justify-items: center;
  max-width: 40px;

  @media (max-width: 760px) {
    font-size: 20px;
  }
`

export const AuthContainer = styled.section`
  justify-self: center;
  margin: 20px;
`

export const Container = styled.main`
  justify-self: center;
  margin: 20px;
`
